import { primary, index, field, table } from './model/decorator';
import Model from './model';
import { StorageEvent } from './event/events';
import * as StorageError from './error/errors';
import { StructuredStorage } from './storage';
export * from '@tencent/memoire-core';
export { primary, index, field, table, StorageEvent, StorageError, Model };
export default StructuredStorage;
//# sourceMappingURL=index.js.map